import { translate } from "../../../utils/translate";
import { DropDownButton } from "../../../components/Toolbar/DropDownButton";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export function ExportButton({ overview, api, allowMSPExport }) {
  const { t } = useTranslation();
  const items = useMemo(() => {
    return [
      {
        text: t("Export to PDF"),
        id: "PDF_PNG",
      },
      ...(allowMSPExport ? [{
        text: t("Export to MSP"),
        id: "MSP",
      }] : []),
    ];
  }, [t, allowMSPExport]);
  const onItemClick = useCallback(
    (id) => {
      if (!api.gantt) {
        console.warn("Gantt instance not available yet");
        return;
      }     
      switch (id) {
        case "PDF_PNG": {
          setTimeout(() => {
            api.gantt.features.print.showPrintDialog();
          });
         
          break;
        }
        case "EXEL": {
          api.gantt.features.excelExporter.export({
            filename: overview.pageTitle,
          });
          break;
        }
        case "MSP": {
          api.gantt.features.mspExport.export({
            filename: overview.pageTitle,
          });
          break;
        }
        default:
          break;
      }
    },
    [api, overview]
  );
  return (
    <DropDownButton
      title={translate("Export")}
      onItemClick={onItemClick}
      items={items}
      id={"download-btn"}
      menuId="preset-btn-menu"
    >
      <span className="ico icon-download2" />
    </DropDownButton>
  );
}
